<div class="custom-checkbox-container">
  <input
    type="checkbox"
    id="cb-{{ id }}"
    value="{{ id }}"
    class="custom-checkbox"
    [disabled]="disabled"
    [checked]="checked"
    [ngClass]="{ indeterminate: indeterminate, error: error, negative: negative }"
    (change)="!disabled && changeValue.emit(checked)"
  />
  <label for="cb-{{ id }}" class="custom-checkbox-label" [ngClass]="{ disabled: disabled }">
    <ng-content />
  </label>
</div>
<p class="error-text">
  <ng-content select="[error]" />
</p>
